export const TARGET_LANGUAGES = [
  { value: "en", label: "English", nativeLabel: "English" },
  { value: "id", label: "Bahasa Indonesia", nativeLabel: "Bahasa Indonesia" },
  { value: "zh", label: "Chinese", nativeLabel: "中文 · 普通话" },
  { value: "th", label: "Thai", nativeLabel: "ไทย" },
] as const;

export type TargetLanguage = (typeof TARGET_LANGUAGES)[number]["value"];

export function isTargetLanguage(value: unknown): value is TargetLanguage {
  return TARGET_LANGUAGES.some((language) => language.value === value);
}
